import css from './filter.scss?inline';
import globalStyles from '../../index.scss?inline';
import { Component } from "../../utils/Component";
import { ArgSpecDictionary } from "../component-utils";

const DEBUG_VERBOSE: boolean = false;
const CLASS_NAME: string = 'HHDSFilter';
export const HHDSFilterTagName: string = "hhds-filter";
const TAG_NAME: string = HHDSFilterTagName;

export const HHDSFilterAttrNames = {
  label: "label",
};

const Attrs = HHDSFilterAttrNames;

let openDropdownInstance: HHDSFilter | null = null;

export class HHDSFilter extends Component {
  private listenerFuncs: { [key: string]: EventListener } = {};
  private dropdownVisible: boolean = false;

  constructor() {
    super();
  }

  protected override init(): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "init");

    const label = this.vars.get<string>(Attrs.label) || "Label";

    this.shadow.innerHTML = `
      <style>${globalStyles}</style>
      <style>${css}</style>
      <div class="${TAG_NAME}">
        <button class="${TAG_NAME}__button">
          <span class="${TAG_NAME}__label bodytext bodytext--02">${label}</span>
          <span class="${TAG_NAME}__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M17.5753 7.94205L11.3253 14.192C11.2673 14.2502 11.1984 14.2963 11.1225 14.3277C11.0466 14.3592 10.9653 14.3754 10.8832 14.3754C10.801 14.3754 10.7197 14.3592 10.6438 14.3277C10.5679 14.2963 10.499 14.2502 10.441 14.192L4.19097 7.94205C4.0737 7.82477 4.00781 7.66571 4.00781 7.49986C4.00781 7.33401 4.0737 7.17495 4.19097 7.05767C4.30825 6.9404 4.46731 6.87451 4.63316 6.87451C4.79901 6.87451 4.95807 6.9404 5.07535 7.05767L10.8832 12.8663L16.691 7.05767C16.749 6.9996 16.818 6.95354 16.8939 6.92211C16.9697 6.89069 17.051 6.87451 17.1332 6.87451C17.2153 6.87451 17.2966 6.89069 17.3725 6.92211C17.4483 6.95354 17.5173 6.9996 17.5753 7.05767C17.6334 7.11574 17.6795 7.18468 17.7109 7.26055C17.7423 7.33642 17.7585 7.41774 17.7585 7.49986C17.7585 7.58198 17.7423 7.6633 17.7109 7.73917C17.6795 7.81504 17.6334 7.88398 17.5753 7.94205Z" fill="#007BBD"/>
            </svg>
          </span>
        </button>
        <div class="${TAG_NAME}__dropdown" style="display: none;">
          <slot></slot>
        </div>
      </div>
    `;

    this.setupEventListeners();
  }

  protected override destroy(): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "destroy");
    this.removeEventListeners();
    if (openDropdownInstance === this) {
      openDropdownInstance = null;
    }
  }

  override onAttributeChanged(name: string, _oldValue: string, newValue: string): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "Attribute changed: ", name, _oldValue, newValue);
    this.reinit();
  }

  override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, elements.length ? "Slot changed" : "Slot emptied");
  }

  static override argSpecs(): ArgSpecDictionary {
    return ArgSpecs;
  }

  private setupEventListeners(): void {
    const button = this.shadow.querySelector(`.${TAG_NAME}__button`) as HTMLButtonElement;
    const dropdown = this.shadow.querySelector(`.${TAG_NAME}__dropdown`) as HTMLDivElement;

    if (!button || !dropdown) return;

    this.listenerFuncs['toggleDropdown'] = (e: Event) => {
      e.stopPropagation();

      if (openDropdownInstance && openDropdownInstance !== this) {
        openDropdownInstance.closeDropdown();
      }

      this.dropdownVisible = !this.dropdownVisible;
      dropdown.style.display = this.dropdownVisible ? 'block' : 'none';
      openDropdownInstance = this.dropdownVisible ? this : null;
    };

    this.listenerFuncs['dismissDropdown'] = (event: Event) => {
      if (!this.dropdownVisible) return;

      const path = event.composedPath();
      const button = this.shadow.querySelector(`.${TAG_NAME}__button`);
      const dropdown = this.shadow.querySelector(`.${TAG_NAME}__dropdown`);

      const clickedInside =
        (button && path.includes(button)) ||
        (dropdown && path.includes(dropdown));

      if (!clickedInside) {
        this.closeDropdown();
      }
    };

    button.addEventListener('click', this.listenerFuncs['toggleDropdown']);
    document.addEventListener('click', this.listenerFuncs['dismissDropdown']);
  }

  private removeEventListeners(): void {
    const button = this.shadow.querySelector(`.${TAG_NAME}__button`) as HTMLButtonElement;

    if (button && this.listenerFuncs['toggleDropdown']) {
      button.removeEventListener('click', this.listenerFuncs['toggleDropdown']);
    }

    if (this.listenerFuncs['dismissDropdown']) {
      document.removeEventListener('click', this.listenerFuncs['dismissDropdown']);
    }
  }

  private closeDropdown(): void {
    const dropdown = this.shadow.querySelector(`.${TAG_NAME}__dropdown`) as HTMLElement | null;
    if (dropdown) {
      dropdown.style.display = 'none';
    }
    this.dropdownVisible = false;
    if (openDropdownInstance === this) {
      openDropdownInstance = null;
    }
  }
}

export const ArgSpecs: ArgSpecDictionary = {
  label: {
    description: "Label displayed inside the button.",
    defaultValue: 'Label',
    typeString: "Label",
    type: String,
  }
};